module.exports = __webpack_public_path__ + "files/c3eb43c071a0adab99c8d7c6af70ea92.png";